import { useState, useEffect, useCallback } from 'react';
import { getCurations } from '../api/curationService';
import { CurationStore } from '../types/curation';
import { useAddress } from '../contexts/AddressContext';
import { DEFAULT_COORDINATES } from '../config/constants';

/**
 * 특정 큐레이션 카테고리의 상세 데이터를 가져오는 커스텀 훅
 */
export const useCurationDetail = (categoryId: string) => {
  const [stores, setStores] = useState<CurationStore[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { address } = useAddress();

  const fetchCurationDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // 주소 컨텍스트에서 좌표 정보 가져오기, 없으면 기본 좌표 사용
      const coordinates = {
        lat: address?.lat ?? DEFAULT_COORDINATES.lat,
        lng: address?.lng ?? DEFAULT_COORDINATES.lng
      };
      
      const data = await getCurations(coordinates.lat, coordinates.lng);
      
      // 해당 카테고리의 stores 찾기
      const targetCuration = data.curationResults.allResults.find(
        curation => curation.category === categoryId
      );
      
      if (targetCuration && !targetCuration.isEmpty) {
        setStores(targetCuration.stores);
      } else {
        setStores([]);
      }
    } catch (err) {
      console.error('Failed to fetch curation detail:', err);
      setError('큐레이션 상세 정보를 불러오는데 실패했습니다.');
      setStores([]);
    } finally {
      setLoading(false);
    }
  }, [categoryId, address]);

  useEffect(() => {
    fetchCurationDetail();
  }, [fetchCurationDetail]);

  return { stores, loading, error, refetch: fetchCurationDetail };
}; 